var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGasCylinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.027,
    height: 50,
    viewBox: "0 0 28.027 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gas-cylinder",
    d: "M134.717,11.278V4.395h.586A2.2,2.2,0,0,0,135.3,0H117.725a2.2,2.2,0,0,0,0,4.395h.586v6.884a6.6,6.6,0,0,0-5.811,6.544v20.8a6.589,6.589,0,0,0,2.881,5.445v2.27A3.666,3.666,0,0,0,119.043,50h14.941a3.666,3.666,0,0,0,3.662-3.662v-2.27a6.589,6.589,0,0,0,2.881-5.445v-20.8a6.6,6.6,0,0,0-5.811-6.544ZM117.725,2.93a.732.732,0,0,1,0-1.465H135.3a.732.732,0,0,1,0,1.465Zm15.527,1.465V11.23h-1.758V4.395Zm-4.9,3.313h-3.675a.732.732,0,0,0,0,1.465h1.105V11.23H123V4.395h7.031V11.23h-2.783V9.172h1.105a.732.732,0,1,0,0-1.465Zm-6.818-3.313V11.23h-1.758V4.395Zm14.648,41.943a2.2,2.2,0,0,1-2.2,2.2H119.043a2.2,2.2,0,0,1-2.2-2.2V44.82a6.561,6.561,0,0,0,2.246.395h14.844a6.561,6.561,0,0,0,2.246-.395Zm2.881-7.715a5.133,5.133,0,0,1-5.127,5.127H119.092a5.133,5.133,0,0,1-5.127-5.127v-20.8a5.133,5.133,0,0,1,5.127-5.127h14.844a5.133,5.133,0,0,1,5.127,5.127Z",
    transform: "translate(-112.5)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasCylinder);
export default __webpack_public_path__ + "static/media/gas-cylinder.d4853bc30c8fee040b8dec78fde6eaa4.svg";
export { ForwardRef as ReactComponent };